import { useState } from 'react';

import { apiAddWord, apiGetWord } from 'core/api';
import usePromiseQuery from 'core/helpers/usePromiseQuery';
import { useMessageModal } from 'core/ui/MessageModal';

import useValidation from './useValidation';

type TStep = 'edit' | 'preview';

export default function useBatchCreatorForm(
  deck: TDeck,
  close: (cards: TWord[] | null) => void
) {
  const [template, setTemplate] = useState<string>('');
  const { showError, showMessage } = useMessageModal();

  const [onSave, isFetching] = usePromiseQuery(
    async (event?: React.FormEvent): Promise<void> => {
      event?.preventDefault();
      await Promise.all(
        cards.map(card =>
          apiAddWord(deck.uid, card).then(wordUid => apiGetWord(wordUid))
        )
      )
        .then(cards => {
          close(cards);
          showMessage(`New ${cards.length} cards were added to the deck!`);
        })
        .catch(showError);
    }
  );

  const [step, setStep] = useState<TStep>('edit');

  const { errors, cards, isEmpty } = useValidation(template, deck.lang);

  const onSubmit = (evt: { preventDefault: () => void }) => {
    evt.preventDefault();

    if (step === 'edit') {
      setStep('preview');
    } else if (!errors.length) {
      onSave().catch(showError);
    }
  };

  return {
    template,
    onChange: setTemplate,
    onSubmit,
    isFetching,
    step,
    setStep,
    errors,
    cards,
    isEmpty,
  };
}
